module.exports = __webpack_public_path__ + "img/fob_pin_blue.5055eeea.svg";